// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__wbM7n","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__6ghLI"};